import { render, staticRenderFns } from "./CoutNombreParSousDepartement.vue?vue&type=template&id=65f3ba0a&scoped=true"
import script from "./CoutNombreParSousDepartement.vue?vue&type=script&lang=js"
export * from "./CoutNombreParSousDepartement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3ba0a",
  null
  
)

export default component.exports